import {
  ActionType,
  IConsentStatementResponse,
} from "models/consentStatement/getConsentStatement";

export const getConsentStatementAction = () => {
  return {
    type: ActionType.GET_CONSENT_STATEMENT,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.GET_CONSENT_STATEMENT_ERROR,
    payload,
  };
};

export const handleSuccessAction = (payload: IConsentStatementResponse) => {
  return {
    type: ActionType.GET_CONSENT_STATEMENT_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.GET_CONSENT_STATEMENT_RESET,
  };
};
